module.exports = __webpack_public_path__ + "assets/mp3.png";